import { render, staticRenderFns } from "./TncIndex.vue?vue&type=template&id=4b9bc428&scoped=true&"
import script from "./TncIndex.vue?vue&type=script&lang=js&"
export * from "./TncIndex.vue?vue&type=script&lang=js&"
import style0 from "./TncIndex.vue?vue&type=style&index=0&id=4b9bc428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9bc428",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b9bc428')) {
      api.createRecord('4b9bc428', component.options)
    } else {
      api.reload('4b9bc428', component.options)
    }
    module.hot.accept("./TncIndex.vue?vue&type=template&id=4b9bc428&scoped=true&", function () {
      api.rerender('4b9bc428', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/settings/engineers/regionConfig/TncIndex.vue"
export default component.exports